import React from 'react';
import cn from 'classnames';

import styles from './button.module.scss';

interface IProps {
  className?: string;
  variant?: 'text' | 'primary' | 'secondary';
  size?: 'small' | 'medium' | 'big';
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

const Button: React.FC<IProps> = (props) => {
  const {
    className,
    children,
    variant = 'primary',
    size = 'medium',
    onClick,
    type = 'button',
    disabled
  } = props;

  const buttonClassName = cn(
    styles.button,
    className,
    styles[`button__${size}`],
    styles[`button__${variant}`]
  );

  return (
    <button
      className={buttonClassName}
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default Button;
